import dayjs from 'dayjs'

interface CommonDate {
  currentYear: string[],
  currentMonth: string[],
  currentDay: string[],
  pastOneYear: string[],
  pastOneMonth: string[],
  nowDate: string
}

// 生成默认时间
function defaultDateFun(format = 'YYYY-MM-DD HH:mm:ss'): CommonDate {
  const dayJsTime = dayjs(new Date())
  const STARTYEAR = dayJsTime.format('YYYY-01-01 00:00:00')
  const STARTMONTH = dayJsTime.format('YYYY-MM-01 00:00:00')
  const STARTDAY = dayJsTime.format('YYYY-MM-DD 00:00:00')
  const NOW = dayJsTime.format('YYYY-MM-DD 23:59:59') // 今天
  const NOW2 = dayJsTime.format('YYYY-MM-DD') // 今天2

  let nowDate = dayjs(NOW).format(format)

  let newYear: number[] = NOW2.split('-')
  newYear[0]--
  let pastOneYear = [dayjs(`${newYear.join('-')} 00:00:00`).format(format), nowDate]

  let newYear2 = NOW2.split('-')
  if (+newYear2[1] === 1) {
    newYear2[0]--
    newYear2[1] = 12
  } else {
    newYear2[1]--
  }
  let pastOneMonth = [dayjs(`${newYear2.join('-')} 00:00:00`).format(format), nowDate]

  return {
    currentYear: [dayjs(STARTYEAR).format(format), nowDate],
    currentMonth: [dayjs(STARTMONTH).format(format), nowDate],
    currentDay: [dayjs(STARTDAY).format(format), nowDate],
    pastOneYear,
    pastOneMonth,
    nowDate
  }
}

export const commonDate = defaultDateFun()